import React from 'react';
import { views } from '../../../constants/propertyOptions';
import { FormField } from '../../../components/FormField';
import { PromotionBasicInfo } from './promotion/PromotionBasicInfo';
import { PromotionUnits } from './promotion/PromotionUnits';
import { PromotionFeatures } from './promotion/PromotionFeatures';
import { PromotionProjectInfo } from './promotion/PromotionProjectInfo';
import { PromotionConstruction } from './promotion/PromotionConstruction';
import { PromotionSecurity } from './promotion/PromotionSecurity';
import { PromotionCommonAreas } from './promotion/PromotionCommonAreas';
import { PromotionCommercial } from './promotion/PromotionCommercial';
import { PromotionAmenities } from './promotion/PromotionAmenities';

interface PromotionOptionsProps {
  formData: any;
  property?: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

export const PromotionOptions: React.FC<PromotionOptionsProps> = ({
  formData,
  property,
  handleInputChange,
}) => {
  return (
    <div className="space-y-8">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white border-b pb-2">
        Caractéristiques de la promotion
      </h3>

      <PromotionProjectInfo formData={formData} property={property} handleInputChange={handleInputChange} />

      <div className="border-t pt-6">
        <PromotionBasicInfo formData={formData} property={property} handleInputChange={handleInputChange} />
      </div>

      <div className="border-t pt-6">
        <FormField label="Vue">
          <select
            name="view"
            value={property?.view || formData.view || ''}
            onChange={handleInputChange}
            className="w-full"
          >
            <option value="">Sélectionner</option>
            {views.map(view => (
              <option key={view} value={view}>{view}</option>
            ))}
          </select>
        </FormField>
      </div>

      <div className="border-t pt-6">
        <PromotionUnits formData={formData} property={property} handleInputChange={handleInputChange} />
      </div>

      <div className="border-t pt-6">
        <PromotionConstruction formData={formData} property={property} handleInputChange={handleInputChange} />
      </div>

      <div className="border-t pt-6">
        <PromotionCommonAreas formData={formData} property={property} handleInputChange={handleInputChange} />
      </div>

      <div className="border-t pt-6">
        <PromotionFeatures formData={formData} property={property} handleInputChange={handleInputChange} />
      </div>

      <div className="border-t pt-6">
        <PromotionSecurity formData={formData} property={property} handleInputChange={handleInputChange} />
      </div>

      <div className="border-t pt-6">
        <PromotionAmenities formData={formData} property={property} handleInputChange={handleInputChange} />
      </div>

      <div className="border-t pt-6">
        <PromotionCommercial formData={formData} property={property} handleInputChange={handleInputChange} />
      </div>
    </div>
  );
};